<app-header></app-header>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple"></ngx-spinner>

<div class="form-group col-md-10 mar-top-10">
  <div class="head_title">{{'Supplier Address Database' | translate}}</div>
</div>
<form name="form" (ngSubmit)="this.onChangeTable(this.config, true)" #f="ngForm" novalidate>
  <div class="row no-mar-lr">
    <div class="form-group col-md-2 mar-top-30  mar-rgt-40  mar-lft-30 ">
      <label>{{'SUPPLIERCODE' | translate}}</label>
      <ng-multiselect-dropdown *ngIf="supplierCodeList"  name="suppliercodes" [settings]="settingssuppliercode" [data]="supplierCodeList" 
        [(ngModel)]="suppliercodes"  (onSelect)="onSingleSelectSupplierCode($event)"
        (onDeSelect)="onDeSelectSupplierCode($event)" (onSelectAll)="onSelectAllSupplierCode($event)" (onDeSelectAll)="DeSelectAllSupplierCode($event)"></ng-multiselect-dropdown>
    </div>
    <div class=" mar-top-60 mar-rgt-20">
      <p>- {{'OR' | translate}} -</p>
    </div>
    <div class="form-group col-md-2 mar-top-30 mar-rgt-40">
      <label>{{'Supplier Name' | translate}}</label>
      <ng-multiselect-dropdown  *ngIf="supplierNameList" name="suppliernames" [settings]="settingssupplierName" [data]="supplierNameList"
        [(ngModel)]="suppliernames"  (onSelect)="onSingleSelectSupplierName($event)"
        (onDeSelect)="onDeSelectSupplierName($event)" (onSelectAll)="onSelectAllSupplierName($event)" (onDeSelectAll)="DeSelectAllSupplierName($event)"></ng-multiselect-dropdown>
    </div>

    <div class="form-group col-md-3 mar-top-30">

      <!-- <button type="submit" [disabled]=" userIDTaken " value="Register" class="btn btn-dark ">Search</button> -->

      <button type="submit" [disabled]="userIDTaken" value="Register" class="btn btn-dark ">
        {{'Search' | translate}}
      </button>
    </div>
  </div>
</form>

<div class="row no-mar-lr">
  <div class="col-md-10 mar-btm-30 mar-lft-30 ">
    <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination> -->
    <section class="part_search_bar">
      <div class="row ">
        <div class="col-md-7 search_input">
          <div class="input-group">
            <input  placeholder="{{'SEARCHBY' | translate}}" [(ngModel)]="srchValue"
              class="form-control">
            <span class="input-group-btn">
              <button class="btn btn-light" type="button" (click)="onChangeTable(config)" [disabled]="rows.length <= 0">
                {{'Search' | translate}}
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-4">
          <button [disabled]="notallowed" class="row_title btn btn-dark" (click)="exportCSV()">{{'Export Supplier Address Database' | translate}}</button>
        </div>
      </div>
    </section>
    <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" (cellClicked)="onCellClick($event)" [rows]="rows"
      [columns]="columns">
    </ng-table> -->

    <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page" [totalItems]="length"
      [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false" (pageChanged)="onChangeTable(config, $event)"
      (numPages)="numPages = $event">
    </pagination>


   
    
    <div class="example-container mat-elevation-z8">
    
      <mat-table [dataSource]="dataSource" >
    
        <ng-container matColumnDef="partNumber">
          <mat-header-cell *matHeaderCellDef > Part Number </mat-header-cell>
          <mat-cell *matCellDef="let row" > <a class="partno_column" [routerLink] ="['/partDetails/partsInfo/', row.packageId]" routerLinkActive="router-link-active">{{row.partNumber}}</a></mat-cell>
        </ng-container>
    
       
        <ng-container matColumnDef="supplierCode">
          <mat-header-cell *matHeaderCellDef > Supplier Code </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="suppName">
          <mat-header-cell *matHeaderCellDef > Supplier Name </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.suppName}} </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="prodPoint">
          <mat-header-cell *matHeaderCellDef > Production Point </mat-header-cell>
          <mat-cell *matCellDef="let row" > {{row.prodPoint}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="shipPoint">
          <mat-header-cell *matHeaderCellDef > Shipping Point </mat-header-cell>
          <mat-cell *matCellDef="let row" > {{row.shipPoint}} </mat-cell>
        </ng-container>
    
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>
     
    </div> 
    


    <div *ngIf="rows.length <= 0" class="tbl_noRecord">
      {{'No Records Found' | translate}}
    </div>
  </div>
</div>